import React from 'react'
import * as joda from '@js-joda/core'
import { useCurrentTime } from '../hooks'

type TimeEventEmitterProps = {
  epoch:joda.Instant
  delay:joda.Duration
  onEmit:() => void
}

/**
 * WARNING: changes to `onEmit` will not reset `hasEmitted`
 */
export default React.memo((props:TimeEventEmitterProps) => {
  const [stateHasEmitted,setHasEmitted] = React.useState(false)
  useCurrentTime((currentTime) => {
    if(!stateHasEmitted && currentTime.isAfter(props.epoch.plus(props.delay)))
    {
      console.log('emitting',props.delay,props.epoch)
      setHasEmitted(true)
      props.onEmit()
    }
  })
  React.useEffect(() => {
    setHasEmitted(false)
  },[props.epoch,props.delay])
  return <></>
},(prev,next) => {
  console.log('time-event-emitter',prev.delay,next.delay,prev.epoch,next.epoch)
  return prev.delay.compareTo(next.delay) === 0 && prev.epoch.compareTo(next.epoch) === 0
})
